import { Link, useParams } from 'react-router-dom'

import { Layout } from 'components/layout'
import { Container } from 'components/container'
import { useDataContext } from 'context/data-context'
import { PersonType } from 'models'
import { Subtitle, Title, List, Hr } from './styled'
import { useEffect, useState } from 'react'

const filterPeople = (people: PersonType[], query: string) => {
  return people.filter(
    (p) => !query || `${p.Name}`.toLowerCase().indexOf(query.toLowerCase()) >= 0
  )
}

export const Search = () => {
  const params = useParams()
  const { people, translate } = useDataContext()
  const search = decodeURIComponent(params.search ?? '')
  const [results, setResults] = useState<PersonType[]>([])

  const searchResults = async () => {
    const res = filterPeople(people, search)

    if (res.length > 0) {
      setResults(filterPeople(people, search))
    }
  }

  useEffect(() => {
    if (search) {
      void searchResults()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search])

  return (
    <Layout>
      <Container>
        <Title>{translate('Search page title')}</Title>
        {translate('You were looking for')}: "{search}"
        <Hr />
        <Subtitle>{translate('Result')}</Subtitle>
        {results.length > 0 ? (
          <List>
            {results.map((v) => (
              <li key={v.id}>
                <Link to={`/detail/${v.id}`}>{v.Name}</Link>
              </li>
            ))}
          </List>
        ) : (
          <p>{translate('Nothing was found')}</p>
        )}
      </Container>
    </Layout>
  )
}
